var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Chip, Drawer, Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { getAlertsByJobCardIdURL } from "../../../api/url";
import { ChevronRightIcon } from "../../../assets/customIcons";
import { CrossIcon, FlagAlert } from "../../../assets/images";
import { MuiButton, MuiStack } from "../../../components";
import { MuiIconButton } from "../../../components/atoms/iconButtonComponent";
import { JC_ALERT_TYPES, LOCAL_STORAGE_KEYS } from "../../../constants";
import { getListAPI, resetState } from "../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { systemColor } from "../../../theme/systemColor";
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { AlertDetailsComponent } from "../AlertDetailsComponent";
import AlertDetailsDelay from '../AlertDetailsDelay';
import { AlertDetailsRecall } from "../AlertDetailsRecall";
import { AlertDetailsRepeat } from "../AlertDetailsRepeat";
import { AlertDetailsRevisit } from "../AlertDetailsRevisit";
import HexFileAccordion from '../hexFile/hexfileAccordion';
var OptionAlert = function (props) {
    var jobCardId = props.jobCardId, JobcardNo = props.JobcardNo, difference = props.difference, EstimatedDateTime = props.EstimatedDateTime, previousJobcard = props.previousJobcard, InstallBaseId = props.InstallBaseId, isCreateDocumentFlow = props.isCreateDocumentFlow, isDocumentDisabled = props.isDocumentDisabled, documentStatusKey = props.documentStatusKey, NoPadding = props.NoPadding;
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var dispatch = useAppDispatch();
    var _a = useState([]), alertsList = _a[0], setAlertsList = _a[1];
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var repeatRevisitReasonListHeaderLevel = getLocalStorageItem(LOCAL_STORAGE_KEYS.REPEAT_REVISIT_REASON_LIST_HEADERLEVEL);
    var repeatRevisitReasonListLineLevel = getLocalStorageItem(LOCAL_STORAGE_KEYS.REPEAT_REVISIT_REASON_LIST_LINELEVEL);
    var _c = useState(""), repeatRevisitId = _c[0], setRepeatRevisitId = _c[1];
    var _d = useState(''), remark = _d[0], setRemark = _d[1];
    var storedSelectedChannel = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
    var _e = useAppSelector(function (state) { return state.crud; }), callGetAlerts = _e.callGetAlerts, getAlertsByJobCardId = _e.getAlertsByJobCardId;
    var getJobCardAlerts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload, _result$payload2, _result$payload3, requestBody, result, _result$payload4, _UpdatedList, UpdatedList, dummyAlerts;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        SystemName: documentStatusKey ? documentStatusKey : null,
                        InstallBaseId: InstallBaseId
                    };
                    if (isCreateDocumentFlow) { }
                    else {
                        requestBody.ParentId = jobCardId;
                    }
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: 'getAlertsByJobCardId',
                            url: getAlertsByJobCardIdURL,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.success && result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && (_result$payload2 = _result$payload2.value) !== null && _result$payload2 !== void 0 && _result$payload2.data && result !== null && result !== void 0 && (_result$payload3 = result.payload) !== null && _result$payload3 !== void 0 && (_result$payload3 = _result$payload3.value) !== null && _result$payload3 !== void 0 && (_result$payload3 = _result$payload3.data) !== null && _result$payload3 !== void 0 && _result$payload3.Alerts) {
                        UpdatedList = __spreadArray([], (result === null || result === void 0 || (_result$payload4 = result.payload) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.value) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.data) === null || _result$payload4 === void 0 ? void 0 : _result$payload4.Alerts), true);
                        UpdatedList = (_UpdatedList = UpdatedList) === null || _UpdatedList === void 0 ? void 0 : _UpdatedList.map(function (item, index) {
                            if (index === 0) {
                                return _objectSpread(_objectSpread({}, item), {}, {
                                    isExpanded: true
                                });
                            }
                            else {
                                return _objectSpread(_objectSpread({}, item), {}, {
                                    isExpanded: false
                                });
                            }
                        });
                        dummyAlerts = [{
                                "AlertId": "4c3c7f7c-ab45-4595-90d4-5d7496e9da06",
                                "AlertName": "Repeat",
                                isExpanded: false
                            }, {
                                "AlertId": "4c3c7f7c-jsif-4595-90d4-5d7496e9da06",
                                "AlertName": "Recall",
                                isExpanded: false
                            }, {
                                "AlertId": "294u09-jsif-4595-90d4-5d7496e9da06",
                                "AlertName": "Hex file",
                                isExpanded: false
                            }, {
                                "AlertId": "294u09-jsif-4595-90d4-5d7496e92980",
                                "AlertName": "Delayed",
                                isExpanded: false
                            }];
                        setAlertsList(UpdatedList);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var _getAlertsByJobCardId;
        if (getAlertsByJobCardId && (getAlertsByJobCardId === null || getAlertsByJobCardId === void 0 || (_getAlertsByJobCardId = getAlertsByJobCardId.data) === null || _getAlertsByJobCardId === void 0 || (_getAlertsByJobCardId = _getAlertsByJobCardId.Alerts) === null || _getAlertsByJobCardId === void 0 ? void 0 : _getAlertsByJobCardId.length) > 0) {
            var _getAlertsByJobCardId2, _UpdatedList2;
            var UpdatedList = __spreadArray([], (getAlertsByJobCardId === null || getAlertsByJobCardId === void 0 || (_getAlertsByJobCardId2 = getAlertsByJobCardId.data) === null || _getAlertsByJobCardId2 === void 0 ? void 0 : _getAlertsByJobCardId2.Alerts), true);
            UpdatedList = (_UpdatedList2 = UpdatedList) === null || _UpdatedList2 === void 0 ? void 0 : _UpdatedList2.map(function (item, index) {
                if (index === 0) {
                    return _objectSpread(_objectSpread({}, item), {}, {
                        isExpanded: true
                    });
                }
                else {
                    return _objectSpread(_objectSpread({}, item), {}, {
                        isExpanded: false
                    });
                }
            });
            setAlertsList(UpdatedList);
        }
        else {
            if (jobCardId || InstallBaseId) {
                getJobCardAlerts();
            }
        }
        return function () {
            dispatch(resetState(['getAlertsByJobCardId']));
        };
    }, []);
    var toggleDrawer = function () {
        setOpen(!open);
    };
    var handleAlertAccordian = function (alertIndex) {
        var updatedAlertsList = __spreadArray([], alertsList, true);
        var updatedItem = _objectSpread({}, updatedAlertsList[alertIndex]);
        updatedItem.isExpanded = !updatedItem.isExpanded;
        updatedAlertsList[alertIndex] = updatedItem;
        setAlertsList(updatedAlertsList);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, alertsList && Array.isArray(alertsList) && alertsList.length > 0 && /*#__PURE__*/ React.createElement(MuiStack, {
        px: NoPadding ? 0 : 2,
        pt: NoPadding ? 0 : 2
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            height: 'auto',
            backgroundColor: systemColor.white,
            border: '1px solid #FFDD99',
            borderRadius: '8px',
            display: 'flex',
            placeItems: 'center',
            justifyContent: 'space-between'
        },
        p: "8px 8px 8px 12px"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        gap: '8px',
        justifyContent: 'flex-start',
        flexWrap: 'wrap'
    }, alertsList.map(function (alertItem, index) { /*#__PURE__*/ return React.createElement(Box, {
        key: index,
        sx: {
            display: 'inline-flex',
            justifyContent: 'space-evenly',
            borderRadius: '6px',
            backgroundColor: '#FFF7E5',
            placeItems: 'center',
            padding: '2px 8px'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: alertItem.AlertName === JC_ALERT_TYPES.Repeat ? "Revisited" : alertItem.AlertName,
        color: '#CC7A00',
        variant: "h3"
    }, alertItem.AlertName === JC_ALERT_TYPES.Repeat ? "Revisited" : alertItem.AlertName)); })), /*#__PURE__*/ React.createElement(MuiButton, {
        variant: "text",
        endIcon: /*#__PURE__*/ React.createElement(ChevronRightIcon, null),
        sx: {
            padding: '2px 8px'
        },
        name: "Alerts",
        size: "small",
        onClick: toggleDrawer
    })))), /*#__PURE__*/ React.createElement(Drawer, {
        onClose: toggleDrawer,
        open: open,
        anchor: IS_DESKTOP ? 'right' : 'bottom',
        sx: {
            display: {
                xs: "block"
            },
            "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                borderRadius: IS_DESKTOP ? "" : "12px 12px 0 0px"
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            width: IS_DESKTOP ? "450px" : "100%"
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        padding: "20px 0 0px 20px"
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 1
    }, /*#__PURE__*/ React.createElement("img", {
        id: "flagIcon",
        src: FlagAlert
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 9
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "alert-details",
        style: {
            fontSize: '16px',
            fontWeight: '600',
            marginLeft: "10px",
            marginTop: "6px"
        },
        color: "black"
    }, "Alert Details")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 1,
        alignItems: 'end',
        textAlign: 'right'
    }, /*#__PURE__*/ React.createElement(MuiIconButton, {
        onClick: toggleDrawer,
        style: {
            justifyContent: 'flex-end'
        },
        id: "cancelButton"
    }, /*#__PURE__*/ React.createElement("img", {
        id: "crossIconBtn",
        src: CrossIcon
    }))))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        padding: "16px",
        spacing: 1
    }, alertsList === null || alertsList === void 0 ? void 0 : alertsList.map(function (alertItem, index) {
        return /*#__PURE__*/ React.createElement("div", {
            key: index
        }, /*#__PURE__*/ React.createElement(Accordion, {
            expanded: alertItem.isExpanded,
            onChange: function () {
                handleAlertAccordian(index);
            },
            sx: {
                border: "1px solid #DEE4EB",
                boxShadow: "none",
                borderRadius: "8px !important"
            },
            key: 'panel' + index
        }, /*#__PURE__*/ React.createElement(AccordionSummary, {
            expandIcon: /*#__PURE__*/ React.createElement(ExpandMoreIcon, {
                id: "".concat(alertItem.AlertName === JC_ALERT_TYPES.Repeat ? "Revisited" : alertItem.AlertName, "-expand-icon")
            }),
            "aria-controls": "panel".concat(index, "bh-content"),
            id: "panel".concat(index, "bh-header"),
            sx: {
                "&.MuiAccordionSummary-content.Mui-expanded": {
                    margin: 0
                },
                margin: '0 !important',
                padding: '12px',
                minHeight: 'unset !important',
                '&.Mui-expanded': {
                    minHeight: 'unset !important'
                },
                '& .MuiAccordionSummary-content': {
                    margin: '0 !important'
                }
            }
        }, alertItem.AlertName === JC_ALERT_TYPES.Recall ? /*#__PURE__*/ React.createElement(Stack, null, /*#__PURE__*/ React.createElement(Stack, {
            direction: 'row',
            gap: '12px'
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "Recalls",
            color: '#1B1D21',
            fontSize: 'medium'
        }, "Recalls"), /*#__PURE__*/ React.createElement(Chip, {
            id: "recall-chip",
            variant: "filled",
            sx: {
                border: 'none',
                borderRadius: '6px',
                padding: '2px 8px',
                bgcolor: 'warning.50',
                color: 'warning.600'
            },
            label: 'Recall'
        })), /*#__PURE__*/ React.createElement(Typography, {
            id: "active-recall-count",
            fontSize: 'sm',
            color: '#8593A3'
        }, "2 active recalls are available ")) : /*#__PURE__*/ React.createElement(Typography, {
            id: alertItem.AlertName === JC_ALERT_TYPES.Repeat ? "Revisited" : alertItem.AlertName,
            fontWeight: 500,
            fontSize: 14
        }, alertItem.AlertName === JC_ALERT_TYPES.Repeat ? "Revisited" : alertItem.AlertName)), /*#__PURE__*/ React.createElement(AccordionDetails, null, alertItem.AlertName === JC_ALERT_TYPES.Repeat ? /*#__PURE__*/ React.createElement(AlertDetailsRepeat, {
            documentStatusKey: documentStatusKey,
            isCreateDocumentFlow: isCreateDocumentFlow,
            repeatRevisitReasonListHeaderLevel: repeatRevisitReasonListHeaderLevel,
            repeatRevisitReasonListLineLevel: repeatRevisitReasonListLineLevel,
            alertId: alertItem.AlertId,
            jobCardId: jobCardId,
            JobcardNo: JobcardNo,
            previousJobcard: previousJobcard,
            toggleDrawer: toggleDrawer,
            InstallBaseId: InstallBaseId,
            callApIStatus: alertItem.isExpanded,
            isDocumentDisabled: isDocumentDisabled
        }) : alertItem.AlertName === JC_ALERT_TYPES.Revisit ? /*#__PURE__*/ React.createElement(AlertDetailsRevisit, {
            repeatRevisitReasonList: repeatRevisitReasonListHeaderLevel,
            alertId: alertItem.AlertId,
            jobCardId: jobCardId,
            JobcardNo: JobcardNo,
            previousJobcard: previousJobcard,
            toggleDrawer: toggleDrawer,
            remark: remark,
            repeatRevisitId: repeatRevisitId,
            setRemark: setRemark,
            setRepeatRevisitId: setRepeatRevisitId
        }) : alertItem.AlertName === JC_ALERT_TYPES.Recall ? /*#__PURE__*/ React.createElement(AlertDetailsRecall, {
            repeatRevisitReasonList: repeatRevisitReasonListHeaderLevel,
            alertId: alertItem.AlertId,
            jobCardId: jobCardId,
            JobcardNo: JobcardNo,
            previousJobcard: previousJobcard,
            toggleDrawer: toggleDrawer,
            remark: remark,
            repeatRevisitId: repeatRevisitId,
            setRemark: setRemark,
            setRepeatRevisitId: setRepeatRevisitId
        }) : alertItem.AlertName === JC_ALERT_TYPES.HexFile ? /*#__PURE__*/ React.createElement(HexFileAccordion, null) : alertItem.AlertName === JC_ALERT_TYPES.Delayed ? /*#__PURE__*/ React.createElement(AlertDetailsDelay, {
            jobCardDetails: null
        }) : /*#__PURE__*/ React.createElement(AlertDetailsComponent, {
            repeatRevisitReasonList: repeatRevisitReasonListHeaderLevel,
            alertId: alertItem.AlertId,
            jobCardId: jobCardId,
            JobcardNo: JobcardNo,
            repeatRevisitId: repeatRevisitId,
            setRepeatRevisitId: setRepeatRevisitId,
            remark: remark,
            setRemark: setRemark,
            EstimatedDateTime: EstimatedDateTime
        }))));
    })))));
};
export default OptionAlert;
